import { motion } from "framer-motion";

const stats = [
  { value: "1958", key: "founded" },
  { value: "3", key: "generations" },
  { value: "100%", key: "made" },
  { value: "UAE", key: "delivery" },
];

export const Heritage = ({ t }) => (
  <section id="heritage" data-testid="heritage-section" className="pt-24 lg:pt-32 pb-12 lg:pb-16 bg-[#F5F2EC]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#A67C00] mb-4">
            {t.heritage.overline}
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#2D1810] tracking-tight leading-tight">
            {t.heritage.title}
          </h2>
          <div className="mt-10 relative">
            <div className="overflow-hidden rounded-sm">
              <img
                src="/images/door-arch.webp"
                alt={t.gallery.items["door-arch"]}
                data-testid="heritage-image"
                className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-[#2D1810] text-[#F5F2EC] px-6 py-5 rounded-sm max-w-[240px]">
              <p className="font-serif italic text-base leading-snug">“{t.heritage.quote}”</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-7 lg:pt-16"
        >
          <p className="text-base sm:text-lg text-[#3E2723]/80 leading-relaxed">{t.heritage.p1}</p>
          <p className="mt-6 text-base sm:text-lg text-[#3E2723]/80 leading-relaxed">{t.heritage.p2}</p>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 border border-[#3E2723]/15 rounded-sm divide-x divide-y md:divide-y-0 divide-[#3E2723]/15">
            {stats.map((s) => (
              <div key={s.key} data-testid={`stat-${s.key}`} className="p-6">
                <p className="font-serif text-3xl sm:text-4xl text-[#3E2723] font-semibold">{s.value}</p>
                <p className="mt-2 text-xs uppercase tracking-[0.15em] text-[#5D4037]">{t.stats[s.key]}</p>
              </div>
            ))}
          </div>

          <div className="mt-14 overflow-hidden rounded-sm">
            <img
              src="/images/dining-room.webp"
              alt={t.gallery.items["dining-room"]}
              data-testid="heritage-image-2"
              className="w-full aspect-[16/9] object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
